import { notOnlyWhitespace, onlyLetters } from "@lib/validators/regex/general";
import { object, string } from "yup";
import type { DeliveryStepFormErrorHeaders } from "../deliveryStepValidationSchema";
import { companyMaxLength } from "@config/site/site-config";

const FIRST_NAME_MAX_LENGTH = 25;
const LAST_NAME_MAX_LENGTH = 25;
const COMPANY_MAX_LENGTH = companyMaxLength;
const STREET_NAME_MAX_LENGTH = 40;
const POSTAL_CODE_MAX_LENGTH = 10;
const ADDITIONAL_ADDRESS_INFO_MAX_LENGTH = 40;
const CITY_MAX_LENGTH = 40;
const COUNTRY_MAX_LENGTH = 40;

export const getSharedSchema = (
    headers: DeliveryStepFormErrorHeaders,
    labels: {
        firstName?: string;
        lastName?: string;
        company?: string;
        streetName?: string;
        postalCode?: string;
        city?: string;
        country?: string;
    }
) => {
    return object().shape({
        company: string().when("isCompany", {
            is: true,
            then: (schema) =>
                schema
                    .label(labels.company)
                    .matches(notOnlyWhitespace, headers.requiredField)
                    .max(COMPANY_MAX_LENGTH, headers.maxCompanyCharacters)
                    .required(),
            otherwise: (schema) => schema.nullable(),
        }),
        firstName: string().when("isCompany", {
            is: true,
            then: (schema) => schema.nullable(),
            otherwise: (schema) =>
                schema
                    .label(labels.firstName)
                    .matches(notOnlyWhitespace, headers.requiredField)
                    .matches(onlyLetters, headers.firstName)
                    .max(FIRST_NAME_MAX_LENGTH, headers.maxNameCharacters)
                    .required(),
        }),

        lastName: string().when("isCompany", {
            is: true,
            then: (schema) => schema.nullable(),
            otherwise: (schema) =>
                schema
                    .label(labels.lastName)
                    .matches(notOnlyWhitespace, headers.requiredField)
                    .matches(onlyLetters, headers.lastName)
                    .max(LAST_NAME_MAX_LENGTH, headers.maxNameCharacters)
                    .required(),
        }),
        streetName: string()
            .label(labels.streetName)
            .matches(notOnlyWhitespace, headers.requiredField)
            .max(STREET_NAME_MAX_LENGTH, headers.maxAddressCharacters)
            .required(),
        additionalAddressInfo: string()
            .max(ADDITIONAL_ADDRESS_INFO_MAX_LENGTH, headers.maxAddressCharacters)
            .nullable(),
        postalCode: string()
            .label(labels.postalCode)
            .matches(notOnlyWhitespace, headers.requiredField)
            .max(POSTAL_CODE_MAX_LENGTH, headers.zipCodeValid)
            .required(),
        city: string()
            .label(labels.city)
            .matches(notOnlyWhitespace, headers.requiredField)
            .matches(onlyLetters, headers.cityNumbers)
            .max(CITY_MAX_LENGTH, headers.maxAddressCharacters)
            .required(),
        country: string()
            .label(labels.country)
            .max(COUNTRY_MAX_LENGTH, headers.maxAddressCharacters)
            .required(),
    });
};
